import { composeIO } from 'react-compose-io'
import { vincularOPSIO } from './VincularOPS.IO'
import VincularOPSView from './VincularOPS.View'

export const VincularOPS = composeIO(VincularOPSView, vincularOPSIO)
